<ion-header>
  <ion-toolbar>
    <ion-title class="ion-text-center">
      <span class="icon icon-{{ order.filter_module }} header-title ion-margin-end"></span
      ><span>{{ order.context_title }}</span>
    </ion-title>

    <ion-buttons class="header-buttons" slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <p *ngIf="order.type === 'single_order'" class="customer-info ion-text-center">{{ customerName }}</p>
  <p
    *ngIf="order.filter_module !== 'collect_at_counter'"
    class="fulfillment-info ion-text-center"
    [innerHTML]="fulfillmentSummary"
  ></p>

  <div class="docket-details">
    <div class="ph-no ion-text-center" *ngIf="order.type === 'single_order'">{{ order.customer.phone }}</div>

    <ion-list class="docket-details-list">
      <ion-item>
        <p *ngIf="order.type === 'batch_order'">Order Batch Reference</p>
        <p *ngIf="order.type === 'single_order'">Order Reference</p>
        <p slot="end">{{ order.id }}</p>
      </ion-item>

      <ng-container *ngIf="order.type === 'batch_order'">
        <ion-item *ngFor="let customer of order.batch_customers">
          <p>{{ customer.first_name }} ({{ customer.phone }})</p>
          <p slot="end">{{ order.getUserOrderId(customer.phone) }}</p>
        </ion-item>
      </ng-container>

      <ion-item>
        <p>Order Time</p>
        <p slot="end">{{ orderTimeStr }}</p>
      </ion-item>

      <ion-item *ngIf="order.context_type !== 'dinein'">
        <p>Order Requested</p>
        <p slot="end">{{ requestedTimeStr }}</p>
      </ion-item>

      <ion-item *ngIf="order.context_type !== 'dinein'">
        <p>ETA</p>
        <p *ngIf="!etaStr" slot="end" color="primary" class="warning-color">NOT SET</p>
        <p *ngIf="etaStr" slot="end">{{ etaStr }}</p>
      </ion-item>

      <ion-item>
        <p>Total</p>
        <p slot="end">
          <strong>{{ order.total | currency: core.Active_server.currency:'symbol-narrow' }}</strong>
        </p>
      </ion-item>

      <ion-item>
        <p>Paid</p>
        <ion-icon *ngIf="order.paid" slot="end" name="thumbs-up" class="good-color"></ion-icon>
        <ion-icon *ngIf="!order.paid" slot="end" name="thumbs-down" class="bad-color"></ion-icon>
      </ion-item>

      <ion-item>
        <p>Payment</p>
        <ion-img slot="end" [src]="paymentIconSrc"></ion-img>
      </ion-item>
    </ion-list>
  </div>
</ion-content>

<ion-footer class="ion-text-center hub-btn-container">
  <ion-button *ngIf="!order.eta" class="eta-btn" shape="round" size="large" (click)="setEta()">
    <ion-icon class="ion-margin-end" name="alarm-outline"></ion-icon>
    {{ etaBtnLabel }}
  </ion-button>

  <ion-button
    *ngIf="order.eta"
    class="print-btn"
    shape="round"
    size="large"
    (click)="print()"
    [disabled]="!printer.Has_active_printers"
  >
    <ion-icon class="ion-margin-end" name="print-outline"></ion-icon>
    Print
  </ion-button>
</ion-footer>
